<template>
  <div class="mulitiple-cotaine">
    <el-table v-show="tableData.length" :data="tableData" border style="width: 100%" height="700">
      <el-table-column prop="dt" label="报警日期"></el-table-column>
      <el-table-column prop="deviceName" label="设备号"></el-table-column>
      <el-table-column prop="nuclear_alarm_count" label="报警序号"></el-table-column>
      <el-table-column prop="min_log_time" label="报警开始时间"></el-table-column>
      <el-table-column prop="max_log_time" label="报警结束时间"></el-table-column>
      <el-table-column label="报警实际倍数">
        <template #default="scope">
          <span v-if="scope.row.multiple !== 'NaN'">{{ scope.row.multiple }}</span>
          <span v-else>-</span>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
export default {
  components: {},
  props: {
    tableData: {
      type: Array
    }
  },
  data() {
    return {
      showTableArr: []
    };
  },
  watch: {
    tableData: {
      handler(newVal) {
        this.showTableArr = newVal;
      },
      deep: true,
      immediate: true
    }
  },
  computed: {},
  methods: {},
  created() {},
  mounted() {}
};
</script>
<style lang="scss" scoped></style>
